import { InjectionToken } from '@angular/core';

export type formbrowsestate = 'browse' | 'stable';
export type formeditstate = 'read' | 'write';

export const IS_BASE_FORROOT_GUARD = new InjectionToken<void>(
  'IS_BASE_FORROOT_GUARD'
);
